import CitaService from "@/services/CitaService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const citaTemp = {
    namespace:true,
    state: {citaTemps:{},fail:true,searchNotification:0,paramether:[] },
    actions: {
        async getListCitatemp({commit},pageNumber){
            return await CitaService.getlistTemp(pageNumber).then(
                response=>{    
                    commit('setCitaTemp',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListCitatemp({commit},search){          
            return await CitaService.getSearchTemp(search).then (
                response =>{                    
                    commit('setCitaTemp',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure',false)
                    return Promise.reject(error)
                }
            );
        },
        async filterListCitatemp({commit},search){          
           return await CitaService.getfilterTemp(search).then (
                response =>{                    
                    commit('setCitaTemp',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure',false)
                    return Promise.reject(error)
                }
            );
        },        
        
    },
  mutations: {
    setCitaTemp(state,data){
        state.citaTemps = data
    },
    setFailure(state,data){
        state.fail = data
    },
    setCurrentPage(state,data){
        state.citaTemps.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};